/**
 * Утилиты для работы со временем и датами.
 * 
 * formatMinutes — форматирует минуты в "X мин" или "X ч Y мин"
 * Применяется: Workshop, InProgressOrderView, Diagnostic
 * 
 * getElapsedMinutes — считает сколько минут прошло с dateStr до сейчас
 * Применяется: Workshop, InProgressOrderView, Diagnostic
 * 
 * formatTime — форматирует дату в "ЧЧ:ММ"
 * Применяется: InProgressOrderView
 * 
 * formatSeconds — форматирует секунды в "М:СС"
 * Применяется: Diagnostic (таймер записи голоса)
 * 
 * getPeriodDates — возвращает { from, to } по выбранному периоду (today/week/month/custom)
 * Применяется: Ros, Workshop, Master/OrderList, Mechanic/OrderList
 */

export function formatMinutes(minutes) {
    if (!minutes && minutes !== 0) return '—'
    if (minutes < 60) return `${minutes} мин`
    const h = Math.floor(minutes / 60)
    const m = minutes % 60
    return m > 0 ? `${h} ч ${m} мин` : `${h} ч`
}

export function getElapsedMinutes(dateStr) {
    if (!dateStr) return null
    return Math.floor((Date.now() - new Date(dateStr).getTime()) / 60000)
}

export function formatTime(dateStr) {
    if (!dateStr) return '—'
    const d = new Date(dateStr)
    return d.toLocaleTimeString('ru-RU', { timeZone: 'Europe/Moscow', hour: '2-digit', minute: '2-digit' })
}

export function formatSeconds(s) {
    const m = Math.floor(s / 60)
    const sec = s % 60
    return `${m}:${sec.toString().padStart(2, '0')}`
}

export function getPeriodDates(period, filterFrom = '', filterTo = '') {
    const to = new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Moscow', year: 'numeric', month: '2-digit', day: '2-digit' }).format(new Date())
    if (period === 'today') return { from: to, to }
    if (period === 'week') {
        const d = new Date(`${to}T00:00:00Z`)
        d.setUTCDate(d.getUTCDate() - 7)
        return { from: d.toISOString().split('T')[0], to }
    }
    if (period === 'month') {
        const d = new Date(`${to}T00:00:00Z`)
        const day = d.getUTCDate()
        d.setUTCDate(1)
        d.setUTCMonth(d.getUTCMonth() - 1)
        const lastDay = new Date(Date.UTC(d.getUTCFullYear(), d.getUTCMonth() + 1, 0)).getUTCDate()
        d.setUTCDate(Math.min(day, lastDay))
        return { from: d.toISOString().split('T')[0], to }
    }
    return { from: filterFrom, to: filterTo }
}

export const isInvalidDateRange = (from, to) => Boolean(from && to && from > to)
